export const UserTypes = {
    SET_SIGNED_IN_USER_PROFILE: "SET_SIGNED_IN_USER_PROFILE",
    CLEAR_SIGNED_IN_USER_PROFILE: "CLEAR_SIGNED_IN_USER_PROFILE",
    SET_SIGNED_IN_USER_SESSION: "SET_SIGNED_IN_USER_SESSION",
    CLEAR_SIGNED_IN_USER_SESSION: "CLEAR_SIGNED_IN_USER_SESSION",
}